import interviews from "./interviews";

export const INTERVIEWS_NAMESPACE = `bookings/interviews`;

export default interviews;
